<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('studentEnrollment.forwardOrPromotionClass') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-group">
            <div class="radio radio-css radio-inline">
              <input
                type="radio"
                id="forward"
                v-model="model.trans_type"
                value="1"
              />
              <label for="forward" class="ts-cursor-pointer">
                {{
                  $t(
                    'studentEnrollment.forwardClass'
                  )
                }}
              </label>
            </div>
            <div class="radio radio-css radio-inline">
              <input
                type="radio"
                id="promotion"
                v-model="model.trans_type"
                value="2"
              />
              <label for="promotion" class="ts-cursor-pointer">
                {{
                  $t(
                    'studentEnrollment.promotionClass'
                  )
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">{{
              $t('studentEnrollment.currentClass')
            }}</label>
            <treeselect
              :load-options="loadCurrentClass"
              :multiple="false"
              :options="currentClass"
              :placeholder="$t('select')"
              v-model.number="model.old_class_id"
              @select="value => (acp_id = value.acp_id)"
            />
            <div class="validate" v-if="errors.has('old_class_id')">
              {{ errors.first('old_class_id') }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">{{
              $t('studentEnrollment.newClass')
            }}</label>
            <treeselect
              :multiple="false"
              :options="forwardClass"
              :disabled="!acp_id ? true : false"
              :placeholder="$t('select')"
              v-model.number="model.new_class_id"
            />
            <div class="validate" v-if="errors.has('new_class_id')">
              {{ errors.first('new_class_id') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div id="container-table">
              <ts-table
                :columns="columns"
                :records="resources"
                :loading="loading"
                :showCheckbox="true"
                @check-items="checkItem"
              >
                <template v-slot="{ record }">
                  <td>{{ record.student_profile.card_number }}</td>
                  <td>{{ record.student_profile.full_name_en }}</td>
                  <td>{{ record.student_profile.gender }}</td>
                  <td>{{ record.student_profile.phone }}</td>
                </template>
              </ts-table>
            </div>
            <div class="validate" v-if="errors.has('student_list')">
              {{ errors.first('student_list') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button @click="$emit('close')" class="mr-2">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            color="primary"
            outline
            class="mr-2"
            :waiting="waiting_new"
            @click.prevent="storeStudentForwardNew"
            >{{ $t('save_add_new') }}</ts-button
          >
          <ts-button
            color="primary"
            :waiting="waiting"
            @click.prevent="storeStudentForward"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'classForward',
  data() {
    return {
      model: {
        old_class_id: null,
        new_class_id: null,
        student_list: [],
        trans_type: 1
      },
      resources: [],
      loading: false,
      forwardClass: null,
      currentClass: null,
      acp_id: 0,
      waiting: false,
      waiting_new: false,
      errors: new Errors()
    }
  },
  created() {},
  computed: {
    columns() {
      return [
        { name: this.$t('studentEnrollment.studentCard') },
        { name: this.$t('studentEnrollment.studentName') },
        { name: this.$t('studentEnrollment.gender') },
        { name: this.$t('studentEnrollment.phone') }
      ]
    }
  },
  methods: {
    ...mapActions('studentEnrollment', [
      'getClassOperation',
      'fetchStudentEnrollByClass'
    ]),
    storeStudentForward() {
      this.waiting = true
      this.$store
        .dispatch('studentEnrollment/storeStudentForward', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    storeStudentForwardNew() {
      this.waiting_new = true
      this.$store
        .dispatch('studentEnrollment/storeStudentForward', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    filterStudent(class_id) {
      if (this.model.old_class_id != undefined) {
        this.loading = true
        this.fetchStudentEnrollByClass({
          page: -1,
          filter: {
            class_id: this.model.old_class_id
          }
        })
          .then(response => {
            this.resources = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.acp_id = 0
      }
    },
    checkItem(items) {
      this.model.student_list = items.map(el => el.student_id)
    },
    async loadCurrentClass({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getClassOperation({
          page: -1,
          filter: {
            ac_status_id: '1'
          }
        })
          .then(response => {
            this.currentClass = response.data.map(el => ({
              acp_id: el.acp_id,
              id: el.class_id,
              label:
                el.class_name +
                ' | ' +
                el.teacher.fname_foreign +
                ' ' +
                el.teacher.lname_foreign +
                ' | ' +
                el.academic_study_time.study_time
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    loadForwardClass() {
      this.options = null
      if (this.acp_id) {
        this.getClassOperation({
          filter: {
            acp_id: this.acp_id,
            class_of_current_and_next_grade: this.model.old_class_id,
            ac_status_id: '3'
          },
          trans_type: this.model.trans_type,
          page: -1
        })
          .then(response => {
            this.forwardClass = response.data.map(el => ({
              id: el.class_id,
              label:
                el.class_name +
                ' | ' +
                el.teacher.fname_foreign +
                ' ' +
                el.teacher.lname_foreign +
                ' | ' +
                el.academic_study_time.study_time +
                ' (' +
                el.academic_status.ac_status_description +
                ')'
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    clearInput() {
      this.model = {
        old_class_id: null,
        new_class_id: null,
        student_list: []
      }
    }
  },
  watch: {
    'model.old_class_id': function(value) {
      this.model.student_list = []
      this.resources = []
      // this.clearInput()
      this.filterStudent()
      this.loadForwardClass()
    },
    'model.trans_type': function(value) {
      this.model.student_list = []
      this.resources = []
      this.model.old_class_id = null
      this.model.new_class_id = null
    }
  }
}
</script>

<style lang="css" scoped>
#container-table {
  min-height: 60vh;
  overflow: scroll;
}
</style>
